import io from 'socket.io-client';
import { ref, watch } from 'vue-demi';
import { sockets } from '@/platform/config/constants';

export default function useRealTimeUpdates({ logger, userContext, accountContext }) {
  const data = ref([]);
  const latest = ref({});
  const socket = ref(null);

  function connect() {
    if (!accountContext.account.value.realTimeNotifications || socket.value) {
      return;
    }

    let url = null;
    if (process.env.NODE_ENV === 'development') {
      url = sockets.dev;
    } else if (process.env.NODE_ENV === 'staging') {
      url = sockets.staging;
    } else {
      url = sockets[accountContext.account.value.awsRegion.toLowerCase()];
    }

    socket.value = io(url, {
      path: `/socket.io/${userContext.user.value.id}`,
      timeout: 5000,
      reconnection: false,
      reconnectionDelay: 500,
      reconnectionAttempts: 100,
      forceNew: true,
      transports: ['websocket'],
    });

    socket.value.on('eventNotice', (event) => {
      latest.value = event;
      data.value = [...data.value, latest.value];
    });

    socket.value.on('connection', (socketInstance) => {
      socketInstance.use((packet, next) => {
        logger.logObject({ packet });
        next();
      });
    });

    socket.value.on('connect', () => {
      socket.value.emit('auth', {
        authToken: userContext.user.value.auth.token,
        fname: userContext.user.value.firstName,
        timestamp: userContext.user.value.auth.timestamp,
        lname: userContext.user.value.lastName,
        installationId: accountContext.account.value.id,
        userId: userContext.user.value.id,
        clientVersion: 1.1,
      });

      socket.value.emit('getSavedUserEvents', {});
    });
  }

  watch(
    [userContext.user, accountContext.account],
    () => {
      if (userContext.user.value && accountContext.account.value) {
        connect();
      }
    },
    { immediate: true },
  );

  return {
    data,
    latest,
    socket,
  };
}
